import {
  createClient,
  navigatorLock,
  type LockFunc,
} from "@supabase/supabase-js";
import { env } from "@/lib/env";

const fallbackUrl = "https://example.supabase.co";
const fallbackAnonKey = "public-anon-key";

export const BROWSER_AUTH_LOCK_ACQUIRE_TIMEOUT_MS = 20_000;

export const browserAuthLock: LockFunc = async (name, acquireTimeout, fn) => {
  if (!globalThis.navigator?.locks) {
    return await fn();
  }

  const effectiveTimeout = acquireTimeout > 0
    ? Math.max(acquireTimeout, BROWSER_AUTH_LOCK_ACQUIRE_TIMEOUT_MS)
    : acquireTimeout;

  return await navigatorLock(name, effectiveTimeout, fn);
};

const browserAuthOptions = {
  autoRefreshToken: true,
  persistSession: true,
  // Auth responses can briefly exceed the SDK's 5s default while the DB is
  // recovering. Waiting longer prevents another tab/WebView request from
  // stealing the shared Navigator Lock and aborting Kakao login completion.
  // supabase-js 2.99 does not forward lockAcquireTimeout to auth-js, so use its
  // supported custom lock hook and preserve the SDK's 0ms nonblocking calls.
  lock: browserAuthLock,
  // Kakao login is completed via a custom callback route. Letting Supabase parse
  // arbitrary hash params here can break the callback because Kakao also returns
  // an access_token in the URL fragment.
  detectSessionInUrl: false,
};

export const supabase = createClient(
  env.supabaseUrl || fallbackUrl,
  env.supabaseAnonKey || fallbackAnonKey,
  {
    auth: browserAuthOptions,
    realtime: {
      params: {
        eventsPerSecond: 5,
      },
    },
  },
);
